import ParticleBackground from './components/ParticleBackground/ParticleBackground';
import CustomCursor from './components/CustomCursor/CustomCursor';
import ScrollProgress from './components/ScrollProgress/ScrollProgress';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Education from './components/Education/Education';
import Career from './components/Career/Career';
import Projects from './components/Projects/Projects';
import GitHub from './components/GitHub/GitHub';
import Blog from './components/Blog/Blog';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import CombinedSkills from './components/Skills/CombinedSkills';

function App() {
  return (
    <div className="App">
      <ParticleBackground />
      <CustomCursor />
      <ScrollProgress />
      <ScrollToTop />
      <Header />
      <Hero />
      <Education />
      <Career />
      <Projects />
      <GitHub />
      <Blog />
      <CombinedSkills />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
